<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="回收申请模板" name="1">
      </el-tab-pane>
      <el-tab-pane label="手术包模板" name="2">
      </el-tab-pane>
      <el-tab-pane label="回收模板" name="3">
      </el-tab-pane>
      <el-tab-pane label="发放申请模板" name="4">
      </el-tab-pane>
    </el-tabs>
    <management ref="management"/>
  </div>
</template>

<script>
import Management from './components/templateManagement.vue'
export default {
    name:'departmentIndex',
    components: {
      Management
    },
    data() {
      return {
        activeName: '1',
      }
    },
    created() {
      this.$nextTick(() => {
        this.handleClick()
      })
    },
    methods: {
      handleClick() {
        this.$refs.management.openTab(Number(this.activeName))
      },
    }
}
</script>

